import { render, staticRenderFns } from "./QualityAssuranceItemsHR.vue?vue&type=template&id=64126cd6&"
import script from "./QualityAssuranceItemsHR.vue?vue&type=script&lang=js&"
export * from "./QualityAssuranceItemsHR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports